
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink"
import { ScrollMobileHeaderItem } from "./categoryHeaderMutamWrapper";

interface MainNavProps {
    scrollItems: ScrollMobileHeaderItem[]
    openHam: () => void
    hideNav?: boolean
}

export class CategoryScrollHeaderMutam extends React.Component<MainNavProps, {}> {

    componentDidMount() {
        const selectedElement = document.querySelector(".nav-scroll-list .selected")
        if (selectedElement) {
            selectedElement.scrollIntoView({ behavior: 'smooth', inline: 'center' })
        }
    }
    
    render() {
        const { scrollItems, openHam, hideNav } = this.props

        return (
            <div className="category-scroll-header-mutam" role="navigation" aria-label="Main Menu">
                {!hideNav && <div className="side-menu-logo icon" onClick={openHam}></div>}

                <div className="menu-fade"></div>

                <div className="nav-scroll-list">
                    {scrollItems.map((item: ScrollMobileHeaderItem, index: number) =>
                        <HyperLinkBuilder href={item.link} linkTarget={item.linkTarget} className={`scroll-item ${item.isSelected ? "selected" : ""}`} key={index}>
                            <span dangerouslySetInnerHTML={{ __html: item.title }} />
                        </HyperLinkBuilder>
                    )}
                </div>
            </div>
        )
    }
}